// extracted by mini-css-extract-plugin
export default {"container":"OZ-z","heading":"PZ-z","links":"QZ-z","copy":"RZ-z","subCopy":"SZ-z","linksLeft":"TZ-z","linksCenter":"UZ-z","linksRight":"VZ-z","link":"WZ-z","onlyLink":"XZ-z"};